export default function traductionLibelleEtat(i18n, listeEtat) {
  const etats = listeEtat;
  etats.forEach((el) => {
    el.libellei18n = i18n.t(el.libelle);
  });
  return etats;
}
